import React, {useState, useEffect} from "react";
import { Button, InputLabel, Paper, TextField, Typography } from '@mui/material';
import { useAuth } from "../../Context/AuthContext";
import { db } from "../../../firebase/firebaseConfig";
import { collection, addDoc, doc, getDoc } from 'firebase/firestore';
import { getStorage, ref, uploadBytesResumable, getDownloadURL } from 'firebase/storage';
import Alerta from "../../../components/Alerta";


const FormularioContactanosDashboard = ({ infoContactanosSeleccionado }) => {

    const isItem = true;
    const [titulo, setTitulo] = useState('');
    const [subtitulo, setSubtitulo] = useState('');
    const [descripcion, setDescripcion] = useState('');
    const [descripcion2, setDescripcion2] = useState('');
    const {usuario} = useAuth();
    const [estadoAlerta, setEstadoAlerta] = useState(false);
    const [alerta, setAlerta] = useState({});
    const [imagen, setImagen] = useState(null); 
    const [modoEdicion, setModoEdicion] = useState(false); // Variable de estado para el modo de edición

    console.log('Estoy en FormularioContactanos ' + infoContactanosSeleccionado);

    useEffect(() => {
        const obtenerInfoContactanos = async () => {
          if (!infoContactanosSeleccionado) return; // Asegúrate de que haya un infoContactanosSeleccionado seleccionado
          try {
            const infoContactanosDoc = await getDoc(doc(db, 'pagecontactanoscalocho', infoContactanosSeleccionado));
            if (infoContactanosDoc.exists()) {
                setModoEdicion(true);
                const infoContactanosData = infoContactanosDoc.data();
                setTitulo(infoContactanosData.titulo || '');
                setSubtitulo(infoContactanosData.subtitulo || '');
                setDescripcion(infoContactanosData.descripcion || '');
                setDescripcion2(infoContactanosData.descripcion2 || '');
                setImagen(infoContactanosData.imagen || null);
            } else {
              console.log('No se encontró el documento');
              setModoEdicion(false);
            }
          } catch (error) {
            console.error('Error al obtener el documento:', error);
          }
        };
      
        obtenerInfoContactanos();
    }, [infoContactanosSeleccionado]); // Asegúrate de que useEffect se ejecute cuando cambie infoContactanosSeleccionado
    
    const handleChange = (e) => {
        if(e.target.name === 'titulo'){
            setTitulo(e.target.value);
        } else if(e.target.name === 'subtitulo'){
            setSubtitulo(e.target.value);
        } else if(e.target.name === 'descripcion'){
            setDescripcion(e.target.value);
        } else if(e.target.name === 'descripcion2'){
            setDescripcion2(e.target.value);
        } else if (e.target.name === 'imagen') {
            const file = e.target.files[0];
            setImagen(file);
        }
    }

    const handleUpload = async (imagen) => {
        if (imagen) {
    
            try {
                const storageRef = getStorage(); // Obtener la instancia de almacenamiento
                const fileRef = ref(storageRef, `pagecontactanoscalocho/${imagen.name}`); // Obtener una referencia al archivo

                // Subir la imagen
                const snapshot = await uploadBytesResumable(fileRef, imagen);
                console.log('Imagen subida correctamente:', snapshot);
    
                // Obtener la URL de descarga
                const downloadURL = await getDownloadURL(snapshot.ref);
                console.log('URL de la imagen:', downloadURL);

                // Mostrar mensaje de éxito
                setEstadoAlerta(true);
                setAlerta({ tipo: 'exito', mensaje: 'Imagen subida correctamente' });
                
                // Devuelve la URL de la imagen
                return downloadURL;

            } catch (error) {
                console.error('Error al subir la imagen:', error);
                setEstadoAlerta(true);
                setAlerta({ tipo: 'error', mensaje: 'Error al subir la imagen' });
                return null;
            }
        } else {
            setEstadoAlerta(true);
            setAlerta({ tipo: 'error', mensaje: 'Por favor selecciona una imagen' });
            return null;
        }
    }

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!imagen) {
            setEstadoAlerta(true);
            setAlerta({ tipo: 'error', mensaje: 'Por favor selecciona una imagen' });
            return;
        }
    
        try {
            const imageUrl = await handleUpload(imagen);

            if(modoEdicion && infoContactanosSeleccionado.id){
                // Crear el objeto de datos actualizado
                //const datosActualizados = {
                  //  titulo: titulo,
                    //subtitulo: subtitulo,
                    //descripcion: descripcion,
                    //descripcion2: descripcion2,
                    //imagen: imageUrl
                //};
    
                // Llamar a la función editarInfoContactanos con los datos actualizados
                //await editarInfoContactanos(infoContactanosSeleccionado.id, datosActualizados);

                // Cambiar el estado de modoEdicion a falso para volver al modo de creación
                setModoEdicion(false);
                
                // Limpiar el formulario después de agregar el infocontactanos
                setTitulo('');
                setSubtitulo('');
                setDescripcion('');
                setDescripcion2('');
                setImagen(null);
                infoContactanosSeleccionado('');
                // Mostrar mensaje de éxito
                setEstadoAlerta(true);
                setAlerta({ tipo: 'exito', mensaje: 'infocontactanos actualizado correctamente' });
            
            } else {
                

                if(imageUrl){
                    // Agregar el infocontactanos a Firestore con la URL de la imagen
                    await addDoc(collection(db, 'pagecontactanoscalocho'), {
                        titulo: titulo,
                        subtitulo: subtitulo,
                        descripcion: descripcion,
                        descripcion2: descripcion2,
                        imagen: imageUrl, // URL de la imagen
                        uidUsuario: usuario.uid
                    });
    
                    // Limpiar el formulario después de agregar el infocontactanos
                    setTitulo('');
                    setSubtitulo('');
                    setDescripcion('');
                    setDescripcion2('');
                    setImagen(null);
    
                    // Mostrar mensaje de éxito
                    setEstadoAlerta(true);
                    setAlerta({ tipo: 'exito', mensaje: 'infocontactanos agregado correctamente' });
                } else {
                    setEstadoAlerta(true);
                    setAlerta({ tipo: 'error', mensaje: 'Error al agregar el infocontactanos' });
                }
            }

            // Limpiar el formulario después de agregar el infocontactanos
            setTitulo('');
            setSubtitulo('');
            setDescripcion('');
            setDescripcion2('');
            setImagen(null);

        } catch (error) {
            console.error(error);
            setEstadoAlerta(true);
            setAlerta({ tipo: 'error', mensaje: 'Error al agregar el infocontactanos' });
        }
    }

    return(
        <Paper onSubmit={handleSubmit} component="form" sx={{ 
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            width: '100%',
            maxWidth: '500px',
            margin: 'auto',
            padding: 2,
            boxShadow: 3,
            borderRadius: 2,
            gap: 2,
            // Añadimos media queries aquí
            '@media (max-width: 1024px)': { // Tablets
                width: '85%',  // Ocupar un poco más de ancho
                padding: 1,  // Reducir el padding
            },
            '@media (max-width: 600px)': {  // Móviles
                width: '100%',  // Ocupar todo el ancho
                padding: 1,  // Padding más pequeño
            },
        }}>
            <Typography variant='h5' sx={{
                width: 'auto',
                alignItems: 'center',
                textAlign: 'center',
                '@media (max-width: 600px)': {  // En móviles, reducir el tamaño del texto
                    fontSize: '1.25rem',  // Ajustamos el tamaño de la fuente
                }
            }}>Nuestra infomación de la página contactanos</Typography>

            <TextField                  
                required
                size="small"
                id="titulo"
                fullWidth
                label="Título de la información contactanos"
                name="titulo"
                value={titulo}
                onChange={handleChange}
                />
            <TextField                  
                required
                size="small"
                fullWidth
                id="subtitulo"
                label="Subtitulo"
                name="subtitulo"
                value={subtitulo}
                onChange={handleChange}/>


            <TextField                  
                required
                fullWidth
                size="small"
                id="descripcion"
                multiline
                label="Descripción de la información contactanos"
                name="descripcion"
                value={descripcion}
                onChange={handleChange}/>

            <TextField                  
                required
                fullWidth
                id="descripcion2"
                multiline
                size="small"
                label="Descripción2 de la información contactanos"
                name="descripcion2"
                value={descripcion2}
                onChange={handleChange}/>

            <InputLabel id="img-label">Seleccione una imagen</InputLabel>
            <TextField                  
                fullWidth
                size="small"
                id="imagen"
                name="imagen"
                type='file'
                onChange={handleChange}
                inputProps={{ accept: 'image/*' }}/>
            <Button item={isItem.toString()} xs={12} sm={6}           
                type="submit"
                fullWidth
                size="small"
                variant="outlined"
                sx={{ mt: 3, mb: 2 }}
            >{infoContactanosSeleccionado ? 'Editar información' : 'Agregar información'}</Button>

            <Alerta 
                tipo={alerta.tipo}
                mensaje={alerta.mensaje}
                estadoAlerta={estadoAlerta}
                setAlerta={setEstadoAlerta}
            /> 
        </Paper>
    );
}

export default FormularioContactanosDashboard;